import createRoute        from '@widesk-ui/tools/createRoute';
import AdvertisementModel from '@models/website/AdvertisementModel';

const route = createRoute.dashboardFromModel(
	AdvertisementModel,
	'AdvertisementDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
